export default __webpack_public_path__ + "static/media/received_667464248731417.75a53668.jpg";